<template>
  <div class="flex flex-col items-center justify-center my-10 px-5 w-full">
    <div class="mb-12 mt-[102px] text-center sm:mt-0">
      <h1 class="font-light mb-4 text-black text-4xl">
        歡迎回來
      </h1>
      <span class="text-gray-500">
        請在下方選擇一個組織。
      </span>
    </div>
    <div
      v-if="!gettingTeams && teams"
      class="choose-team__content w-[448px] sm:w-full"
    >
      <section
        v-for="team in teams"
        :key="team.identification"
        class="
          default-card-border
          flex
          items-center
          justify-between
          last:mb-0
          mb-8
          p-6
          rounded
          sm:flex-col
          sm:items-start
          sm:px-4
          sm:py-2
        "
      >
        <span class="text-2xl text-black">
          {{ team.name }}
        </span>
        <w-button
          :disabled="choosingTeam"
          class="
            flex
            hover:bg-white
            hover:border
            hover:border-primary-500
            hover:text-primary-500
            items-center
            px-4
            py-2
            border-white
            text-primary-500
            sm:px-2
            sm:self-end
          "
          variant="outline"
          @click.prevent="choose(team.identification)"
        >
          <span class="mr-2 text-sm">
            進入組織
          </span>
          <i class="icon-chevron-right-circle" />
        </w-button>
      </section>
    </div>
    <div v-else>Loading...</div>
  </div>
</template>

<script>
import ChooseTeam from './ChooseTeam';

export default ChooseTeam;
</script>

<style lang="scss" scoped>
@import 'ChooseTeam';
</style>
